import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    countryCode: '+91',
    mobileNo: '',
    isOtpSent: false,
    isOtpValidated: false,
    otpError: '',
    isGotUser: false,
    ispasswordUpdateLoading: false,
    isPasswordSaved: false,
    passwordError: ''
};

const forgotPasswordSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        otpPending: (state) => {
            state.isLoading = true;
        },
        otpSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.isOtpSent = true;
            state.countryCode = payload.countryCode;
            state.mobileNo = payload.mobileNo;
        },
        otpFail: (state, { payload }) => {
            state.isLoading = false;
            state.otpError = payload;
        },
        otpValidatePending: (state) => {
            state.isLoading = true;
        },
        otpValidateSuccess: (state) => {
            state.isLoading = false;
            state.isOtpValidated = true;
        },
        otpValidateFail: (state, { payload }) => {
            state.isLoading = false;
            state.otpError = payload;
        },
        resetOtpError: (state) => {
            state.otpError = '';
        },
        editMobileNo: (state) => {
            state.isOtpSent = false;
            state.countryCode = '';
            state.mobileNo = '';
        },
        getUserPending: (state) => {
            state.ispasswordUpdateLoading = true;
        },
        getUserSuccess: (state) => {
            state.ispasswordUpdateLoading = false;
            state.isGotUser = true;
        },
        getUserFail: (state, { payload }) => {
            state.ispasswordUpdateLoading = false;
            state.passwordError = payload;
        },
        updatePasswordPending: (state) => {
            state.ispasswordUpdateLoading = true;
        },
        updatePasswordSuccess: (state) => {
            state.ispasswordUpdateLoading = false;
            state.isPasswordSaved = true;
        },
        updatePasswordFail: (state, { payload }) => {
            state.ispasswordUpdateLoading = false;
            state.passwordError = payload;
        },
        forgotPasswordReset: (state) =>{
            state.countryCode = '';
            state.mobileNo = '';
            state.isOtpSent = false;
            state.isOtpValidated = false;
            state.otpError = '';
            state.isGotUser = false;
            state.ispasswordUpdateLoading = false;
            state.isPasswordSaved = false;
            state.passwordError = '';
        }
    },
});

const { reducer, actions } = forgotPasswordSlice;

export const { otpPending, otpSuccess, otpFail, otpValidatePending, otpValidateSuccess, otpValidateFail, resetOtpError, editMobileNo, getUserPending, getUserSuccess, getUserFail, updatePasswordPending,  updatePasswordSuccess, updatePasswordFail, forgotPasswordReset } = actions;

export default reducer;